import { SxProps } from '@mui/system';
import Spacings from '../ds/theme/common/spacings';
import { solTheme } from '../ds/theme/SolThemeProvider';
import { TypographyOptions } from '@mui/material/styles/createTypography';

const backToLogin: SxProps = {
  textAlign: 'right',
  '& a': {
    marginLeft: Spacings.small2,
    textDecoration: 'underline transparent',
    textUnderlineOffset: '2px',
    color: '#124EDE', // COLORS primary.50
    fontWeight: (solTheme.typography as TypographyOptions)?.body3Medium,
    '&:hover': {
      textDecorationColor: '#124EDE', // COLORS primary.50
    },
  },
};

export default {
  backToLogin,
};
